
export { getFontSize } from "./utils"